import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import ChiSiamoPage from "@/pages/ChiSiamo";
import RiunionePage from "@/pages/Riunione";
import MonteFaetaPage from "@/pages/MonteFaetaPage";
import CosaFacciamoPage from "@/pages/CosaFacciamoPage";
import PartecipaPage from "@/pages/Partecipa";
import SegnalazioniPage from "@/pages/Segnalazioni";
import NewsListPage from "@/pages/NewsList";
import NewsDetailPage from "@/pages/NewsDetail";
import EventiPage from "@/pages/EventiPage";
import ProjectsListPage from "@/pages/ProjectsList";
import ProjectDetailPage from "@/pages/ProjectDetail";
import FaqPage from "@/pages/FaqPage";
import AssociarsiPage from "@/pages/AssociarsiPage";
import ContattiPage from "@/pages/ContattiPage";
import AiutoPuliziaPage from "@/pages/AiutoPuliziaPage";
import MontePisanoPage from "@/pages/MontePisanoPage";
import SentieriPage from "@/pages/SentieriPage";
import DocumentiPage from "@/pages/DocumentiPage";
import ProgettoFaetaPage from "@/pages/ProgettoFaeta";
import AdminProjectsPage from "@/pages/AdminProjects";
import ShopPage from "@/pages/ShopPage";
import RaccoltaOlive from "@/pages/RaccoltaOlive";
import Dona from "@/pages/Dona";
import Trasparenza from "@/components/Trasparenza";
import { AdminDashboard } from "@/components/AdminDashboard";
import NotFoundPage from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chi-siamo" element={<ChiSiamoPage />} />
          <Route path="/news" element={<NewsListPage />} />
          <Route path="/news/:slug" element={<NewsDetailPage />} />
          <Route path="/eventi" element={<EventiPage />} />
          <Route path="/progetti" element={<ProjectsListPage />} />
          <Route path="/progetti/progetto-faeta" element={<ProgettoFaetaPage />} />
          <Route path="/progetti/territorio" element={<ProjectsListPage area="territorio" />} />
          <Route path="/progetti/agricoltura-ambiente" element={<ProjectsListPage area="agricoltura-ambiente" />} />
          <Route path="/progetto-faeta" element={<ProgettoFaetaPage />} />
          <Route path="/progetti/:slug" element={<ProjectDetailPage />} />
          <Route path="/riunione" element={<RiunionePage />} />
          <Route path="/monte-faeta" element={<MonteFaetaPage />} />
          <Route path="/cosa-facciamo" element={<CosaFacciamoPage />} />
          <Route path="/partecipa" element={<PartecipaPage />} />
          <Route path="/associarsi" element={<AssociarsiPage />} />
          <Route path="/segnalazioni" element={<SegnalazioniPage />} />
          <Route path="/aiuto-pulizia" element={<AiutoPuliziaPage />} />
          <Route path="/monte-pisano" element={<MontePisanoPage />} />
          <Route path="/sentieri" element={<SentieriPage />} />
          <Route path="/documenti" element={<DocumentiPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contatti" element={<ContattiPage />} />
          <Route path="/trasparenza" element={<Trasparenza />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/raccolta-olive" element={<RaccoltaOlive />} />
          <Route path="/dona" element={<Dona />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/progetti" element={<AdminProjectsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
